import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        user: null
    },
    actions: {

    },
    mutations: {
        login(state, user) {
            state.user = {
                isLoggedIn: true,
                email: user.email ?? "unknown"
            };
            localStorage.email = state.user.email;
        },
        logout(state) {
            state.user = null;
        },
    }
})
